<header *ngIf="isLoggedIn" [ngClass]="{'hide-menu': router.url == '/telemetry'}">
  <nav class="navbar navbar-expand-lg bg">
    <img alt="Company Logo" class="eco-cc-logo" width="91px" height="36px" src="{{ecoLogo}}" />

    <div id="navbar-menu" class="collapse navbar-collapse float-xs-none" [ngbCollapse]="menuHidden">
      <div class="navbar-nav ml-auto">
        <div class="nav-item color-green" ngbDropdown placement="bottom-center">
          <a id="language-dropdown" class="nav-link border-shape set-font" ngbDropdownToggle>
            <img width="16px" height="16px" src="assets/ic-countrySelection.svg" alt="">&nbsp;&nbsp; {{currentLanguage}}
          </a>
          <div ngbDropdownMenu aria-labelledby="language-dropdown">
            <button class="dropdown-item set-font " *ngFor="let language of languages" (click)="setLanguage(language)">
              {{language.name}}
            </button>
          </div>
        </div>
        <div class="nav-item set-font" ngbDropdown placement="bottom-right">
          <a id="user-dropdown" class="nav-link " title="{{loggedInUser || user.email || 'IDMS user'}}" ngbDropdownToggle>
            <img width="14px" height="16px" src="assets/ic-user.svg" alt=""> &nbsp;&nbsp;{{loggedInUser || user.email || 'IDMS user'}}
          </a>
          <div ngbDropdownMenu aria-labelledby="user-dropdown">
            <a class="dropdown-item color-green set-font" href="{{urls.profileUpdate+'&lang='+language}}" translate>{{labels.profileUpdate | translate}}</a>
            <a class="dropdown-item color-green set-font" href="{{urls.pwdUpdate+'&lang='+language}}" translate>{{labels.changePassword | translate}}</a>
            <a class="dropdown-item color-green set-font" href="{{urls.emailUpdate+'&lang='+language}}" translate>{{labels.changeEmail | translate}}</a>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item color-green set-font" (click)="logout()" translate>{{labels.logout | translate}}</button>
          </div>
        </div>
        <img class="se-logo se-logo-img" alt="se logo" width="auto" height="63px" src='{{seLogo}}' />
      </div>
    </div>
  </nav>
</header>
